import _ from 'lodash';
import { FILLED_CLOSED_OPTIONS } from '../constants/jobConstants';
/**
 * name: The name of the property defined in JIRA seen when requesting getProcurementRequestIssueType / getRipProjectFieldsMeta
 * validationType: The field type. If the field is going to be validated by yup schemas, this property should equal a valid yup type
 * validations: an array of additional validations for the field. If using yup to validate the model, use validations supported by yup
 */

const formatSelectOptions = (options) => {
  return options.map((option) => {
    return { text: option, value: option };
  });
};

const JobModel = _.mapValues(
  {
    closedFilledDate: {
      name: 'Closed/Filled Date',
      validationType: 'date',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    closedFilled: {
      name: 'Closed/Filled',
      validationType: 'string',
      options: formatSelectOptions(FILLED_CLOSED_OPTIONS),
      validations: [
        {
          type: 'required',
        },
      ],
    },
    numberApplicants: {
      name: '# Applicants',
      validationType: 'number',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'integer',
        },
        {
          type: 'min',
          params: [0, 'Valid value is from 0 - 1000'],
        },
        {
          type: 'max',
          params: [1000, 'Valid value is from 0 - 1000'],
        },
      ],
    },
    numberApplicantsInterviewed: {
      name: '# Applicants Interviewed',
      validationType: 'number',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'integer',
        },
        {
          type: 'min',
          params: [0, 'Valid value is from 0 - 1000'],
        },
        {
          type: 'max',
          params: [1000, 'Valid value is from 0 - 1000'],
        },
      ],
    },
    numberOffersMade: {
      name: '# Offers Made',
      validationType: 'number',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'integer',
        },
        {
          type: 'min',
          params: [0, 'Valid value is from 0 - 1000'],
        },
        {
          type: 'max',
          params: [1000, 'Valid value is from 0 - 1000'],
        },
      ],
    },
  },
  (value, key) => ({
    aliasName: value.name,
    ...value,
    id: key,
  })
);

export default JobModel;
